import { HttpRequest, HttpHandler, HttpEvent, HttpResponse } from '@angular/common/http';
import { Injectable, isDevMode, inject } from '@angular/core';
import { EMPTY, Observable, catchError, map, throwError } from 'rxjs';
import { AbxErrorResponse, AbxHttpErrorResponse } from './interceptors';
import { NavigationHubService } from '../navigation-hub/navigation-hub.service';
import { AuthService } from '@auth0/auth0-angular';

@Injectable({
  providedIn: 'root',
})
export class InterceptorService {
  private authService = inject(AuthService);
  private navHubService = inject(NavigationHubService);

  /**
   * Dev-only logging. Suppressed in production builds so full HTTP requests
   * (including auth headers) and responses are never written to the browser
   * console of a deployed app.
   */
  private debug(...args: unknown[]): void {
    if (isDevMode()) {
      console.warn(...args);
    }
  }

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    req = this.initiateAbxSpinner(req);
    // req = this.finializeRequestHeader(req);
    this.debug('request: ', req);
    return next.handle(req).pipe(
      map((event: HttpEvent<unknown>) => {
        if (event instanceof HttpResponse) {
          this.debug('event: ', event);
          this.stopSpinner();
        }
        return event;
      }),
      catchError((failure: AbxHttpErrorResponse) => {
        this.debug('error: ', failure.status);
        if (this.isAbxApiUnauthorizedError(failure.status)) {
          this.navHubService.routeToLogin();
          return EMPTY;
          // if(this.authService.modeAuthToken?.refreshToken){
          //   return this.handle401Error(req, next);
          // } else {
          //   this.navHubService.routeToLogin();
          //   return EMPTY
          // }
        } else {
          this.stopSpinner();
          return throwError(new AbxErrorResponse(failure));
        }
      }),
    );
  }
  private isAbxApiUnauthorizedError(errorStatus: number): boolean {
    return errorStatus === 401;
  }
  private stopSpinner(): void {
    this.debug('stop spinner');
    // if (this.spinnerData) {
    //   this.spinnerService.stop();
    //   this.spinnerData = null;
    // }
  }
  private initiateAbxSpinner(request: HttpRequest<unknown>): HttpRequest<unknown> {
    this.debug('start spinner');
    return request;
  }
}
